export const deviceExplorerTypes = {
    UPDATE_REQUEST: "DEVICE_EXPLORER_UPDATE_REQUEST",
    FETCH_DEVICE_EXPLORER_GRAPH_REQUEST: "DEVICE_EXPLORER_FETCH_GRAPH_REQUEST",
    FETCH_DEVICE_EXPLORER_GRAPH_SUCCESS: "DEVICE_EXPLORER_FETCH_GRAPH_SUCCESS",
    FETCH_DEVICE_EXPLORER_GRAPH_FAILURE: "DEVICE_EXPLORER_FETCH_GRAPH_FAILURE",
};

export const updateRequest = (req) => ({
    type: deviceExplorerTypes.UPDATE_REQUEST,
    payload: req
});

export const fetchDeviceExplorerGraphRequest = (req) => ({
    type: deviceExplorerTypes.FETCH_DEVICE_EXPLORER_GRAPH_REQUEST,
    payload: req
});

export const fetchDeviceExplorerGraphSuccess = (resp) => ({
    type: deviceExplorerTypes.FETCH_DEVICE_EXPLORER_GRAPH_SUCCESS,
    payload: resp
});

export const fetchDeviceExplorerGraphFailure = (error) => ({
    type: deviceExplorerTypes.FETCH_DEVICE_EXPLORER_GRAPH_FAILURE,
    payload: error
});